export enum TransactionStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
  SUCCESS = 'SUCCESS'
  // CANCELLED = 'CANCELLED' // Transaction Should not be marked as Cancel only booking shoyld be marked as cancelled
}

export enum PaymentStatus {
  SETTLEMENT_PENDING = 'SETTLEMENT_PENDING',
  SETTLED = 'SETTLED',
  REFUND_INITIATED = 'REFUND_INITIATED',
  REFUND_NOT_INITIATED = 'REFUND_NOT_INITIATED',
  REFUNDED = 'REFUNDED'
}

export interface Transaction {
  id?: string;
  bookingId: string;
  propId: string;
  userId: string;
  status?: TransactionStatus;
  paymentStatus?: PaymentStatus;
  paymentDate?: Date;
  amount: number;
  createdAt?: Date;
  orderId?: string;
  paymentResponse?:
    | Pick<PayUResponse, 'error' | 'error_Message' | 'status' | 'unmappedstatus' | 'bank_ref_num'>
    | { paymentId: string };
}

export interface PayUResponse {
  mihpayid: string;
  mode: string;
  status: string;
  unmappedstatus: string;
  key: string;
  txnid: string;
  amount: string;
  cardCategory: string;
  discount: string;
  net_amount_debit: string;
  addedon: string;
  productinfo: string;
  firstname: string;
  lastname: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  email: string;
  phone: string;
  udf1: string;
  udf2: string;
  udf3: string;
  udf4: string;
  udf5: string;
  udf6: string;
  udf7: string;
  udf8: string;
  udf9: string;
  udf10: string;
  hash: string;
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
  field8: string;
  field9: string;
  payment_source: string;
  meCode: string;
  PG_TYPE: string;
  bank_ref_num: string;
  bankcode: string;
  error: string;
  error_Message: string;
  cardnum: string;
}

export type RazorpayResponse = RazorpaySuccessResponse | RazorpayErrorResponse;

export interface RazorpaySuccessResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export interface RazorpayErrorResponse {
  error: {
    code: string; // Type of the error (e.g., BAD_REQUEST_ERROR)
    description: string; // Descriptive text about the error
    field: string | null; // Name of the parameter that caused the error (nullable)
    source: string; // Point of failure (e.g., "customer", "business", "internal")
    step: string; // Stage where the transaction failure occurred
    reason: string; // Exact error reason
    metadata?: string;
    // {
    //   payment_id?: string; // Unique identifier of the payment
    //   order_id?: string; // Unique identifier of the order associated with the payment
    //   [key: string]: any; // Additional metadata fields
    // };
  };
}
